/**
 * Splits a full name into first name and last name
 * @param fullName - The full name to split
 * @returns Object with name (first name) and last_name
 * 
 * @example
 * splitFullName("John Smith") // { name: "John", last_name: "Smith" }
 * splitFullName("John Michael Smith") // { name: "John", last_name: "Michael Smith" }
 * splitFullName("John") // { name: "John", last_name: "" }
 * splitFullName("") // { name: "New User", last_name: "" }
 */
export const splitFullName = (fullName: string | null | undefined): { name: string; last_name: string } => {
    if (!fullName || fullName.trim() === "") {
        return { name: "New User", last_name: "" };
    }

    const nameParts = fullName.trim().split(/\s+/);
    
    if (nameParts.length === 1) {
        // Only one name provided, use it as first name
        return { name: nameParts[0], last_name: "" };
    }
    
    // First part is the first name, rest is the last name
    const firstName = nameParts[0];
    const lastName = nameParts.slice(1).join(" ");
    
    return { name: firstName, last_name: lastName };
};

